import { RatioWrapper } from './component.styles.js'
export default RatioWrapper
